import React from "react";
import { connect } from "react-redux";

import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons/faCheckCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import emailImage from "@app/assets/email/top-nav-modal-image.svg";
import { isCurrentUserOwner } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

import styles from "./EmailsNotSupported.module.scss";
import messages from "./messages";

interface EmailsNotSupportedProps {
  className?: string;
  isOwner: boolean;
}

const EmailsNotSupported: React.FC<EmailsNotSupportedProps> = ({ className, isOwner }) => {
  const intl = useIntl();

  return (
    <div className={cn(styles.container, className)}>
      <img alt="email-img" src={emailImage} />
      <div className={styles.title}>{intl.formatMessage(messages.title)}</div>
      <div className={styles.points}>
        {[
          intl.formatMessage(messages.point1),
          intl.formatMessage(messages.point2),
          intl.formatMessage(messages.point3),
          intl.formatMessage(messages.point4),
        ].map((text, index) => (
          <div className={styles.point} key={index}>
            <div>
              <FontAwesomeIcon className={styles.pointIcon} icon={faCheckCircle} />
            </div>
            <div>{text}</div>
          </div>
        ))}
      </div>
      {isOwner && (
        <div>
          <Button
            href="https://share.hsforms.com/1z8c5Kt06SF6ejeJAkG5WBA3is1h"
            target="_blank"
            type="primary"
          >
            {intl.formatMessage(messages.interestedButtonLabel)}
          </Button>
        </div>
      )}
      <div className={styles.interestedDescription}>
        {isOwner
          ? intl.formatMessage(messages.interestedDescription)
          : intl.formatMessage(messages.interestedDescriptionNotOwner)}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  isOwner: isCurrentUserOwner(state),
});

export default connect(mapStateToProps)(EmailsNotSupported);
